import { render, staticRenderFns } from "./CreatedAccountMessage.vue?vue&type=template&id=a382edea&"
import script from "./CreatedAccountMessage.vue?vue&type=script&lang=js&"
export * from "./CreatedAccountMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports